"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastContextProvider = exports.ToastContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ui = require("@dcl/ui");

var _ToastTypes = require("./ToastTypes");

var _uuid = require("uuid");

var _reactDom = require("react-dom");

var _Toast = require("./Toast");

var _constants = require("./constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ToastContext = /*#__PURE__*/_react["default"].createContext(null);

exports.ToastContext = ToastContext;

var ToastContextProvider = function ToastContextProvider(_ref) {
  var children = _ref.children,
      container = _ref.container,
      maxStackedToasts = _ref.maxStackedToasts,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? _ToastTypes.ToastWrapperPosition.TOP_RIGHT : _ref$position,
      handleRemove = _ref.handleRemove;
  var getClassName = (0, _ui.getClassNameFactory)("ToastsWrapper");

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      toasts = _useState2[0],
      setToasts = _useState2[1];

  var add = (0, _react.useCallback)(function (_ref2) {
    var text = _ref2.text,
        type = _ref2.type,
        duration = _ref2.duration;
    var id = (0, _uuid.v4)();
    var newToast = {
      id: id,
      text: text,
      type: type,
      duration: duration
    };

    if (maxStackedToasts === 1) {
      setToasts([newToast]);
      return;
    }

    setToasts(function (prevToasts) {
      return [].concat(_toConsumableArray(prevToasts.slice(-1 * (maxStackedToasts !== null && maxStackedToasts !== void 0 ? maxStackedToasts : _constants.DEFAULT_MAX_STACKED_TOASTS) + 1)), [newToast]);
    });
  }, [setToasts, maxStackedToasts]);
  var remove = (0, _react.useCallback)(function (id) {
    setToasts(function (prevToasts) {
      return prevToasts.filter(function (toast) {
        return toast.id !== id;
      });
    });

    if (handleRemove) {
      handleRemove();
    }
  }, [setToasts]);
  var providerValue = (0, _react.useMemo)(function () {
    return {
      add: add,
      remove: remove
    };
  }, [add, remove]);
  return /*#__PURE__*/_react["default"].createElement(ToastContext.Provider, {
    value: providerValue
  }, children, /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
    className: getClassName({
      modifiers: position
    }),
    "aria-live": "assertive"
  }, toasts.map(function (toast) {
    return /*#__PURE__*/_react["default"].createElement(_Toast.Toast, {
      key: toast.id,
      id: toast.id,
      remove: remove,
      type: toast.type,
      duration: toast.duration
    }, toast.text);
  })), container !== null && container !== void 0 ? container : document.body));
};

exports.ToastContextProvider = ToastContextProvider;